import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { Loading } from "shared";
import { useGetTemplate } from "routes/createContent/api/useGetTemplate";
import TemplateEditor from "./TemplateEditor";
import { TemplateFormData, emptyTemplate, templateToForm } from "./types";

export const TemplateEditorPage: React.VFC<{ readOnly?: boolean }> = ({ readOnly = false }) => {
  const { id } = useParams<{ id?: string }>();
  const templateId = id ? parseInt(id, 10) : null;
  const { data, isLoading, isError } = useGetTemplate(templateId ?? undefined);

  if (templateId && isLoading) {
    return <Loading />;
  }
  if (templateId && isError) {
    return (
      <Box p={4}>
        <Typography color="error">Failed to load template.</Typography>
      </Box>
    );
  }

  const initial: TemplateFormData = templateId && data ? templateToForm(data) : emptyTemplate();
  return <TemplateEditor initialValues={initial} rollout={data?.rollout} readOnly={readOnly} />;
};
